(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Apparition au scroll */
  var els = document.querySelectorAll('.ccx-rv');
  if (!('IntersectionObserver' in window) || reduce) {
    els.forEach(function (e) { e.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
    /* filet de sécurité : rien ne reste caché */
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-in'); }); }, 6000);
  }

  /* Filtres de la sélection */
  document.querySelectorAll('[data-ccx-filter]').forEach(function (bar) {
    var scope = bar.closest('.ccx-shop');
    if (!scope) return;
    var cards = scope.querySelectorAll('.ccx-c');
    bar.addEventListener('click', function (ev) {
      var b = ev.target.closest('.ccx-chip');
      if (!b) return;
      bar.querySelectorAll('.ccx-chip').forEach(function (c) { c.classList.toggle('is-on', c === b); });
      var f = b.getAttribute('data-f');
      cards.forEach(function (c) {
        var tags = ' ' + (c.getAttribute('data-tags') || '') + ' ';
        c.hidden = !(f === 'all' || tags.indexOf(' ' + f + ' ') > -1);
      });
    });
  });

  /* Carrousel des moments */
  document.querySelectorAll('[data-ccx-rail]').forEach(function (wrap) {
    var rail = wrap.querySelector('.ccx-rail');
    var step = function () { var c = rail.querySelector('.ccx-m'); return c ? c.getBoundingClientRect().width + 16 : 320; };
    var prev = wrap.querySelector('[data-ccx-prev]');
    var next = wrap.querySelector('[data-ccx-next]');
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
  });
})();